import { axiosAPI } from 'utils';

const fallbackError = (err) => {
  console.error(err);
  return err?.response?.data || { success: false, error: err?.message || 'Request failed' };
};

export default {
  get() {
    return axiosAPI
      .get('api/admin/general-ui-settings')
      .then((res) => res.data)
      .catch(fallbackError);
  },

  update(params) {
    return axiosAPI
      .put('api/admin/general-ui-settings', params)
      .then((res) => res.data)
      .catch(fallbackError);
  },
};
